var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-list", style: { padding: _vm.marketPadding } },
    [_vm._v("\n\t\t促销展示\n\t")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }